import React from "react";
import { Box, Pagination } from "@mui/material";

const CustomPagination = ({ page, pageSize, handlePageChange, totalData }) => {
  const totalPages = Math?.ceil(totalData / pageSize);

  const handleChange = (event, value) => {
    handlePageChange(value - 1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        padding: "10px",
      }}
    >
      <Pagination
        count={totalPages}  
        page={page + 1}
        onChange={handleChange}
        variant="outlined"
        shape="rounded"
        sx={{
          '& .MuiPaginationItem-root': {
            color:"#000",
            border: '0.5px solid #FFFFFF50',
            '&.Mui-selected': {
              backgroundColor: '#B9CC03',
              color: 'black',
              border: '1px solid #B9CC03',
              '&:hover': {
                backgroundColor: '#B9CC03',
                color: 'black',
              },
            },
          },
          '& .MuiPaginationItem-page': {
            '&:hover': {
              backgroundColor: '#B9CC03',
              color:"black"
            },
          },
          '& .MuiPaginationItem-previousNext': {
            color: '#B9CC03',
            '&.Mui-disabled': {
              color: 'grey',
            },
          },
        }}
      />
    </Box>
  );
};

export default CustomPagination;
